import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { FastField } from 'formik';


const mapEstablishmentToApiEstablishmentDto = (values: ICreateEstablishmentForm): IPostNewEstablishment | {} => {
  let dataMapping: IPostNewEstablishment ;

  if (values.placeID === undefined || values.modemID === undefined ) { return {}; }

    dataMapping = {
      description: values.description,
      placeID: +values.placeID !== 0 ? +values.placeID : null,
      modemID: +values.modemID !== 0 ? +values.modemID : null,
      modemPort: values.modemPort !== "" ? values.modemPort : null,
      unID: values.unID,
      sapCode: values.sapCode !== "" ? values.sapCode : null,
      deleted: false,
      filepath: null, 
      hubType: null, 
      anetVoice: null, 
      comments: null,
      isEmporiki: values.isEmporiki ,
      isCiti: values.isCiti,
    }
  
  return dataMapping;
}


export const createEstablishment = ( {data} : {data: ICreateEstablishmentForm }): Promise<string> => {
  const establishment = mapEstablishmentToApiEstablishmentDto(data);
  return axiosDefaultApi.post(`/api/Establishments/InsertEstablishment`, establishment);
};

type QueryFnType = typeof createEstablishment;

type UseCreateEstablishmentOptions = {
  data: IPostNewEstablishment | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateEstablishment = ({ config }: UseCreateEstablishmentOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Καταστήματος.`, 500);
            console.error('Couldnt create new store', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllEstablishments"])
            addNotification(`Το Κατάστημα Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createEstablishment,
    })
}